import React, { Fragment, useContext } from 'react';
import Avatar from '@mui/material/Avatar';
import { AuthContext } from '../../../context/authContext/AuthContext';
import SidebarFooter from './sidebarFooter.js';
const UserPanel = () => {
  const { user } = useContext(AuthContext);

  return (
    <Fragment>
      <div className="sidebar-user d-flex align-items-center px-3">
        <Avatar
          sx={{
            bgcolor: '#fff7f7',
            width: 40,
            color: '#575a57d4',
            mr: 1,
          }}
        >
          {user?.name?.charAt(0)?.toUpperCase()}
        </Avatar>
        <div>
          <h6 className="f-14">{user?.name?.toUpperCase()}</h6>
          <p>{user?.role?.toUpperCase()}</p>
        </div>
        <SidebarFooter />
      </div>
    </Fragment>
  );
};

export default UserPanel;
